import { TIER_TO_PATHOGENICITY } from "./constants";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";

export const calcColor = (topEvidence) => {
  if (topEvidence) {
    return getPathogenicityColorByAllNames(
      TIER_TO_PATHOGENICITY[topEvidence.tier]
    );
  }
  return null;
};
